import { AddonBeam } from '@bitrise/bitkit';
import React, { useContext, FunctionComponent } from 'react';
import useMediaQueryAppLayout from './useMediaQueryAppLayout';
import { AuthContextTrace } from '../Authenticate/AuthenticateTrace';

interface Props {
  isMenuActive?: boolean;
  onToggleMenu?: () => void;
}

const AppBeam: FunctionComponent<Props> = (props) => {
  const { isMenuActive, onToggleMenu, ...rest } = props;
  const isAppFullLayout = useMediaQueryAppLayout();
  const {
    data: { appTitle, appId },
  } = useContext(AuthContextTrace);

  return (
    <AddonBeam
      {...rest}
      addonIcon="Trace"
      addonName="Trace"
      appLink={`https://app.bitrise.io/app/${appId}`}
      appName={appTitle}
      backgroundColor="grape-4"
      isBeta
      isHamburgerIconActive={isMenuActive}
      isInResponsiveView={!isAppFullLayout}
      onHamburgerIconClick={onToggleMenu}
      textColor="gray-1"
    />
  );
};

export default AppBeam;
